module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "padded"
  }, [_c('el-row', [_c('h3', [_vm._v("Notification e-Mails for "), _c('b', [_vm._v("this " + _vm._s(this.actionData.actionType))])])]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "type": "info",
      "title": "Organisation Emails",
      "description": "The default emails are defined by the system administrator. You can add individual emails here.",
      "show-icon": "",
      "center": "",
      "closable": false
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('thead', [_c('th', [_c('center', [_vm._v(_vm._s(this.actionData.organisation.name) + "\n            "), (_vm.isTelco() || _vm.isSuper()) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.updateEmails('telco', true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sync"
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('th', [_c('center', [_vm._v(_vm._s(this.xolasClient().name) + "\n            "), (_vm.isTowerCo()) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.updateEmails('tower', true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sync"
  })]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', _vm._l((_vm.emails.telco), function(email, index) {
    return _c('div', [_c('el-col', {
      attrs: {
        "span": 18,
        "offset": 2
      }
    }, [(email) ? _c('a', {
      attrs: {
        "href": 'mailto:' + email.email
      }
    }, [_c('i', {
      staticClass: "fa fa-edit-outline"
    }), _vm._v(" " + _vm._s(email.email) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-button', {
      staticStyle: {
        "color": "indianred"
      },
      attrs: {
        "type": "text",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.deleteEmail(_vm.emails.telco, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle"
    })])], 1)], 1)
  }), 0), _vm._v(" "), _c('td', _vm._l((_vm.emails.tower), function(email, index) {
    return _c('div', [_c('el-col', {
      attrs: {
        "span": 18,
        "offset": 2
      }
    }, [(email) ? _c('a', {
      attrs: {
        "href": 'mailto:' + email.email
      }
    }, [_c('i', {
      staticClass: "fa fa-edit-outline"
    }), _vm._v(" " + _vm._s(email.email) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [(_vm.isTowerCo()) ? _c('el-button', {
      staticStyle: {
        "color": "indianred"
      },
      attrs: {
        "type": "text",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.deleteEmail(_vm.emails.tower, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle"
    })]) : _vm._e()], 1)], 1)
  }), 0)]), _vm._v(" "), _c('tr', [_c('td', [(_vm.isTelco() || _vm.isSuper()) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.newTelcoEmail),
      callback: function($$v) {
        _vm.newTelcoEmail = $$v
      },
      expression: "newTelcoEmail"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.newTelcoEmail
    },
    on: {
      "click": function($event) {
        return _vm.addEmail('telco', _vm.newTelcoEmail)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.isTowerCo()) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.newEmail),
      callback: function($$v) {
        _vm.newEmail = $$v
      },
      expression: "newEmail"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.newEmail
    },
    on: {
      "click": function($event) {
        return _vm.addEmail('tower', _vm.newEmail)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])], 1)], 1)], 1) : _vm._e()])])]), _vm._v(" "), _c('tfoot', [_c('td', [_c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.isTelco() || _vm.isSuper()) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "fa fa-envelope",
      "disabled": !_vm.isEnabled
    },
    on: {
      "click": function($event) {
        return _vm.sendTest('telco')
      }
    }
  }, [_vm._v("Send Test Email")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('td', [_c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.isTowerCo()) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "fa fa-envelope",
      "disabled": !_vm.isEnabled
    },
    on: {
      "click": function($event) {
        return _vm.sendTest('tower')
      }
    }
  }, [_vm._v("Send Test Email")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Configure: ")]), _vm._v(" "), _c('check-box', {
    attrs: {
      "disabled": _vm.isTelco() || !_vm.isManager(),
      "no-form": ""
    },
    model: {
      value: (_vm.emails.sendMail),
      callback: function($$v) {
        _vm.$set(_vm.emails, "sendMail", $$v)
      },
      expression: "emails.sendMail"
    }
  }, [_vm._v("\n         Send E-mails\n       ")])], 1)], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-950d8572"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/EmailSetup.vue
// module id = 1594
// module chunks = 0